/**
 * Created by pzf on 2018/11/28
 *
 */
const API_KEY = 'getFeeTypeData';

export default API_KEY;
